import request from '@/router/axios';

//统计分析-头部信息-接口
export const statisticalTopData = (params) => {
    return request({
      url: '/api/blade-stat/analysis/header',
      method: 'get',
      params
    })
  }
// 统计分析-统计数据-呼叫量
export const statisticsDataCnt = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/regionMonth/called',
      method: 'get',
      params
  })
}
// 统计分析-统计数据-完成量
export const statisticsDataDone = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/regionMonth/done',
      method: 'get',
      params
  })
}
// 统计分析-呼叫类型统计
export const workTypeData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/workType',
      method: 'get',
      params
  })
}
// 统计分析-计划类型统计
export const planWorkTypeData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/planWorkType',
      method: 'get',
      params
  })
}

// 统计分析-呼叫量趋势
export const monthTrendData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/monthTrend',
      method: 'get',
      params
  })
}

// 统计分析-救助分布数据
export const regionSalvageData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/regionSalvage',
      method: 'get',
      params
  })
}
// 统计分析-五类青少年分布
export const regionTypeData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/regionType',
      method: 'get',
      params
  })
}
// 统计分析-案件类型呼叫量统计数据
export const youngCrimeTypeData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/youngCrimeType',
      method: 'get',
      params
  })
}

// 统计分析-查询涉案时间分布数据
export const crimeTimeData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/crimeTime',
      method: 'get',
      params
  })
}
// 统计分析-查询法律意识认识统计数据
export const lawRegulationsData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/lawRegulations',
      method: 'get',
      params
  })
}

// 统计分析-文化程度统计数据
export const academicStageData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/academicStage',
      method: 'get',
      params
  })
}
// 统计分析-性别统计数据
export const genderData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/gender',
      method: 'get',
      params
  })
}
// 统计分析-救助涉案年龄统计数据
export const ageSalvageData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/ageSalvage',
      method: 'get',
      params
  })
}

// 统计分析-涉案青少年户籍所在地
export const provinceData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/province',
      method: 'get',
      params
  })
}

// 统计分析-涉案场所
export const placeTypeData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/placeType',
      method: 'get',
      params
  })
}
// 统计分析-涉案家庭类型
export const householdTypeData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/householdType',
      method: 'get',
      params
  })
}
// 统计分析-青少年分析统计数据
export const youngAnalysisData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/youngAnalysis',
      method: 'get',
      params
  })
}
// 统计分析-最新7天工作信息
export const workInfoForLast7DaysData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/workInfoForLast7Days',
      method: 'get',
      params
  })
}
// 统计分析-工作信息类型
export const workInfoForAllData = params => {
  // console.log('get提交', params)
  return request({
      url: '/api/blade-stat/analysis/workInfoForAll',
      method: 'get',
      params
  })
}
